import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './Timer.module.scss';
import classNames from 'classnames';
import * as audioBundle from '../audioBundle';

export default class Timer extends Component {
    static propTypes = {
        start: PropTypes.bool,
        duration: PropTypes.number.isRequired,
        onAlarm: PropTypes.func.isRequired,
    };

    state = {
        remain: 0,
    };

    timers = [];

    addInterval(fn, delay) {
        this.timers.push(setInterval(fn, delay));
    }

    componentDidMount() {
        if (this.props.start) {
            this.startTimer();
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.start && this.props.start) {
            this.startTimer();
        }
        if (!this.props.start) {
            this.clearIntervals();
        }
    }

    startTimer() {
        const {duration} = this.props;
        this.setState({remain: duration});

        const startTimestamp = Date.now();

        this.addInterval(() => {
            const timestamp = Date.now();
            const secondsElapsed = ((timestamp - startTimestamp) / 1000) | 0;
            const nextRemain = Math.max(0, duration - secondsElapsed);

            if (nextRemain !== this.state.remain) {
                audioBundle.play('countdown');
            }

            this.setState({remain: nextRemain});

            if (nextRemain === 0) {
                this.clearIntervals();
                audioBundle.play('alarm');
                this.props.onAlarm();
            }
        }, 100);
    }

    componentWillUnmount() {
        this.clearIntervals();
    }

    clearIntervals() {
        for (const timer of this.timers) {
            clearInterval(timer);
        }
    }

    render() {
        const {remain} = this.state;

        return <div className={styles.timer}>{this.formatSeconds(remain)}</div>;
    }

    formatSeconds(secondNumber) {
        const seconds = secondNumber.toString();
        const align = seconds.length < 2 ? '0' : '';

        return '00:' + align + seconds;
    }
}
